import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {getBaseAreaData, getBaseData, getPhoneNumber, login, validateHoliday} from "@service/commonService";
import {getQueryParams} from "@src/util";
import Holiday from "@component/Holiday";
import { goto } from "@src/route"
import "./flexible";
import "@src/assets/style/index.scss"
import { ignoreAuthPaths } from './config';

const query = getQueryParams()
const root = document.getElementById('root');

async function init() {
	const v = await validateHoliday();
	const {pathname} = location
	if (ignoreAuthPaths.map(res=>res.path).includes(pathname)) {
		ReactDOM.render(
			<React.Fragment>
				<App/>
			</React.Fragment>,
			root
		);
		return
	}
	if (v.errcode === 1000) {
		return ReactDOM.render(
			<React.Fragment>
				<Holiday time={v.errmsg}/>
			</React.Fragment>,
			root
		);
	}
	await login(query['token']).then(() => {
		// 获取基础配置数据
		getBaseData().then(() => null)
		getBaseAreaData().then(() => null)
		getPhoneNumber().then(() => null)
	})

	ReactDOM.render(
		<React.Fragment>
			<App/>
		</React.Fragment>,
		root
	);
}

init().catch(() => {
	goto('/loginError')

	ReactDOM.render(
		<React.Fragment>
			<App/>
		</React.Fragment>,
		root
	);
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
